import { ReviewBar, ReviewsList } from "@repo/components";
import { getProductReviews } from "@repo/server-actions/product";
import { getTranslations } from "next-intl/server";
const Reviews = async ({
  itemId,
  session,
  locale
}) => {
  const t = await getTranslations("Common");
  const reviews = await getProductReviews(itemId, locale);
  const {
    totalElements,
    overallRating,
    content
  } = reviews;
  return <div className="mx-auto py-10 md:max-w-screen-xl" data-sentry-component="Reviews" data-sentry-source-file="Reviews.jsx">
      <ReviewBar totalElements={totalElements} overallRating={overallRating} itemId={itemId} session={session} data-sentry-element="ReviewBar" data-sentry-source-file="Reviews.jsx" />
      {content?.length ? <ul>
          {content?.map(item => <ReviewsList item={item} key={item.id} />)}
        </ul> : <div>
          <p className="text-productDetails-reviewText text-sm font-semibold md:text-base">
            {t("No_Reviews_Yet")}
          </p>
          <p className="text-productDetails-reviewText text-sm">
            {t("Be_The_First_To_Share_Your_Experience")}
          </p>
        </div>}
    </div>;
};
export default Reviews;